var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnswers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF3C27",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.644 1.488a7.125 7.125 0 00-7.126 7.14l.002.18a7.3 7.3 0 001.284 3.919l.009.01.002.021-1.31 3.095 3.12-1.326-.073-.049c1.236.851 2.606 1.29 4.092 1.29a7.125 7.125 0 007.126-7.14c0-3.95-3.184-7.14-7.126-7.14zm0 .68a6.445 6.445 0 016.446 6.46c0 3.574-2.88 6.46-6.446 6.46l-.183-.003a6.378 6.378 0 01-3.369-1.064l-.074-.05-.01-.015a.406.406 0 00-.2-.144.547.547 0 00-.207-.026l-.047.005a.44.44 0 00-.273.135l-.01.012-1.484.631.71-1.676v-.07c0-.08-.002-.132-.014-.2l-.012-.062a.57.57 0 00-.104-.22l-.009-.01.007.01a6.607 6.607 0 01-1.167-3.713c0-3.574 2.88-6.46 6.446-6.46z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.655 10.879c-.144 0-.288-.145-.288-.29V8.93c0-.144.144-.289.288-.289.865 0 1.586-.722 1.586-1.588a1.6 1.6 0 00-1.586-1.589c-.864 0-1.585.722-1.585 1.589 0 .144-.144.289-.288.289s-.289-.145-.289-.29a2.247 2.247 0 012.234-2.238 2.247 2.247 0 012.234 2.239c0 1.083-.792 2.022-1.873 2.166v1.372c-.144.144-.289.289-.433.289z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.713,
    cy: 12.113,
    r: 1
  }))));
}

export default SvgAnswers;